import {Base} from "@/api/Base"

export class EmployeeEntryRecordDelete extends Base {
    path = "employeeEntryRecord/delete"
}